import { Capacitor } from "@capacitor/core"
import { PRODUCT_NAME } from "../product"
import type { NestClientPlatform, PlatformKind } from "./types"

export function classifyPlatform(hasElectronBridge: boolean, capacitorPlatform: string): PlatformKind {
    if (hasElectronBridge) return "electron"
    if (capacitorPlatform === "ios") return "ios"
    if (capacitorPlatform === "android") return "android"
    return "browser"
}

export function currentPlatformKind(): PlatformKind {
    const hasElectronBridge = typeof window !== "undefined" && window.wildlarkAPI !== undefined
    return classifyPlatform(hasElectronBridge, Capacitor.getPlatform())
}

export function nestClientPlatform(kind: PlatformKind = currentPlatformKind()): NestClientPlatform {
    if (kind === "electron") return "desktop"
    if (kind === "ios" || kind === "android") return "mobile"
    return "web"
}

export function nestClientName(kind: PlatformKind = currentPlatformKind()): string {
    if (kind === "electron") return `${PRODUCT_NAME} Desktop`
    if (kind === "ios") return `${PRODUCT_NAME} on iPhone or iPad`
    if (kind === "android") return `${PRODUCT_NAME} on Android`
    return `${PRODUCT_NAME} Web`
}

export function isNativeMobilePlatform(kind: PlatformKind = currentPlatformKind()): kind is "ios" | "android" {
    return kind === "ios" || kind === "android"
}
